import styled from 'styled-components';

export const HaveAccountMain = styled.div`
    margin-top: 15px;
`;
export const HaveAccountTitle = styled.span`
    display: block;
    text-align: center;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 15px;
`;
export const HaveAccountIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 20px;
    margin-bottom: 20px;
`;
export const LoginWithIcon = styled.div`
    button{
        background: #FFFFFF;
        box-shadow: 0px 0px 30px #C4E4E6;
        border-radius: 8px;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;

        &:hover, &:active{
            background: #FFFFFF;
            background-color: #fff !important;
        }
    }
`;
export const HaveAccountText = styled.span`
    display: none;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 15px;

    &.login-text{
        display: flex;
    }
    &.sign-up-text{
        display: flex;
    }
    
    .btn{
        padding: 0 0 0 5px;
        background: transparent;
        border: none;
        color: #016B7B;
        font-weight: 600;
      &:active{
        background: transparent;
        border: none;
        color: #016B7B;
      }  
    }
`;

